import appIcon from '../assets/appLogo/appIcon.png'
import logo from '../assets/appLogo/matnext-only-text.png'

const configData = {
  logo,
  APP_NAME: 'Matnext',
  country: 'in',
  continent: 'na',
  authorization: null,
  countryCode: '+91-',
  contactNumberLength: 10,
  appIcon,
}
export default configData
